<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-classEvaluate__evaluateRule">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <!--        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>-->
        <!--        <el-form-item>
                  <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
                </el-form-item>-->
        <el-form-item>
          <el-button v-if="$hasPermission('classEvaluate:evaluateRule:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('classEvaluate:evaluateRule:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('classmanage:teacher:message')" type="primary" @click="classManageTeacherMessageHandle()">班主任消息通知
          </el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="scoreSet" label="分数设置" header-align="center" align="center"></el-table-column>
        <el-table-column prop="statisticsType" label="统计类型" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.statisticsType === statistics.AVERAGE" size="small" type="success">平均分制</el-tag>
            <el-tag v-else-if="scope.row.statisticsType === statistics.TOTAL_POINTS" size="small" type="success">总分制</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="evaluateType" label="优秀班级类型" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.evaluateType === evaluate.NULL" size="small" type="success">无</el-tag>
            <el-tag v-else-if="scope.row.evaluateType === evaluate.FLAG" size="small" type="success">流动红旗</el-tag>
            <el-tag v-else-if="scope.row.evaluateType === evaluate.STAR" size="small" type="success">五星班级</el-tag>
            <el-tag v-else-if="scope.row.evaluateType === evaluate.victorClass" size="small" type="success">优胜班级</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="isRelationStudent" label="评分是否关联学生" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isRelationStudent === relation.yes" size="small" type="success">是</el-tag>
            <el-tag v-else-if="scope.row.isRelationStudent === relation.no" size="small" type="success">否</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="isAppealMessage" label="申诉通知" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isAppealMessage === isAppealMessage.yes" size="small" type="success">是</el-tag>
            <el-tag v-else-if="scope.row.isAppealMessage === isAppealMessage.no" size="small" type="danger">否</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="rollBack" label="允许撤销" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.rollBack === rollBack.YES" size="small" type="success">是</el-tag>
            <el-tag v-else-if="scope.row.rollBack === rollBack.NO" size="small" type="danger">否</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="isOtherClass" label="大屏端显示其他班级" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isOtherClass === isOtherClass.YES" size="small" type="success">是</el-tag>
            <el-tag v-else-if="scope.row.isOtherClass === isOtherClass.NO" size="small" type="danger">否</el-tag>
          </template>
        </el-table-column>
<!--        <el-table-column prop="isContinue" label="是否允许完成以往争章任务" header-align="center" align="center">-->
<!--          <template slot-scope="scope">-->
<!--            <el-tag v-if="scope.row.isContinue === isOtherClass.YES" size="small" type="success">是</el-tag>-->
<!--            <el-tag v-else-if="scope.row.isContinue === isOtherClass.NO" size="small" type="danger">否</el-tag>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column prop="createDate" label="创建时间" header-align="center" align="center"></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('classEvaluate:evaluateRule:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('classEvaluate:evaluateRule:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
      <!-- 弹窗，班评班主任通知     -->
      <class-manage-head-teacher-message v-if="classManageHeadTeacherMessageVisible"
                                         ref="classManageHeadTeacherMessage"></class-manage-head-teacher-message>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './evaluaterule-add-or-update'
import ClassManageHeadTeacherMessage from '../classmanage/classmanage-head-teacher-message'
import { statistics, evaluate, relation, isAppealMessage, rollBack, isOtherClass } from '@/constant'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/classEvaluate/evaluateRule/page',
        getDataListIsPage: true,
        exportURL: '/classEvaluate/evaluateRule/export',
        deleteURL: '/classEvaluate/evaluateRule',
        deleteIsBatch: true
      },
      classManageHeadTeacherMessageVisible: false,
      evaluate,
      relation,
      statistics,
      isAppealMessage,
      rollBack,
      isOtherClass,
      dataForm: {
        statisticsType: '',
        evaluateType: ''
      }
    }
  },
  methods: {
    classManageTeacherMessageHandle () {
      this.classManageHeadTeacherMessageVisible = true
      this.$nextTick(() => {
        this.$refs.classManageHeadTeacherMessage.init()
      })
    }
  },
  watch: {
  },
  components: {
    AddOrUpdate,
    ClassManageHeadTeacherMessage
  }
}
</script>
